import React from 'react';
import { useTranslation } from 'react-i18next';

import { Section, CheckboxLabel, InputLabel, Input, TooltipHelp, RadioLabel, OptionalSection } from '@weezevent/nacre';

import css from '../../actions.module.css';

const EmailAction = ({ action, handleAction }) => {
    const { t } = useTranslation();

    return (
        <>
            {t('ticket.moderation.statusesTransitions.transition.steps.actions.recipientLabel')}
            <div>
                <RadioLabel bordered inline checked={action.to === 'attendee'} value="attendee" onChange={({ target: { value } }) => handleAction('to', value)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.recipientAttendeeOption')}
                </RadioLabel>
                <RadioLabel bordered inline checked={action.to === 'buyer'} value="buyer" onChange={({ target: { value } }) => handleAction('to', value)}>
                    {t('ticket.moderation.statusesTransitions.transition.steps.actions.recipientBuyerOption')}
                </RadioLabel>
            </div>

            <div className={css['action-card-input']}>
                <InputLabel label={t('ticket.moderation.statusesTransitions.transition.steps.actions.senderLabel')} />
                <Input
                    placeholder={t('ticket.moderation.statusesTransitions.transition.steps.actions.senderLabel')}
                    onChange={({ target: { value } }) => handleAction('identity_id', value)}
                    value={action.identity_id}
                />
            </div>

            <div className={css['action-card-input']}>
                <InputLabel label={t('ticket.moderation.statusesTransitions.transition.steps.actions.mailTemplateLabel')} />
                <Input
                    placeholder={t('ticket.moderation.statusesTransitions.transition.steps.actions.mailTemplateLabel')}
                    onChange={({ target: { value } }) => handleAction('template_id', value)}
                    value={action.template_id}
                />
            </div>

            <OptionalSection
                label={t('ticket.moderation.statusesTransitions.transition.steps.actions.display_options')}
                labelOpen={t('ticket.moderation.statusesTransitions.transition.steps.actions.display_options_closed')}
            >
                <CheckboxLabel
                    label={
                        <span>
                            {t('ticket.moderation.statusesTransitions.transition.steps.actions.sendTicketLabel')}
                            <TooltipHelp triggerOnHover title={t('ticket.moderation.statusesTransitions.transition.steps.actions.sendTicketDesc')} />
                        </span>
                    }
                    onChange={({ target: { checked } }) => handleAction('send_ticket', checked)}
                    checked={action.send_ticket}
                />

                <CheckboxLabel
                    label={
                        <span>
                            {t('ticket.moderation.statusesTransitions.transition.steps.actions.uniqueSendOrderLabel')}
                            <TooltipHelp triggerOnHover title={t('ticket.moderation.statusesTransitions.transition.steps.actions.uniqueSendOrderDesc')} />
                        </span>
                    }
                    onChange={({ target: { checked } }) => handleAction('unique_sending_by_order', checked)}
                    checked={action.unique_sending_by_order}
                />

                <CheckboxLabel
                    label={
                        <span>
                            {t('ticket.moderation.statusesTransitions.transition.steps.actions.replayableActionLabel')}
                            <TooltipHelp triggerOnHover title={t('ticket.moderation.statusesTransitions.transition.steps.actions.replayableActionDesc')} />
                        </span>
                    }
                    onChange={({ target: { checked } }) => handleAction('allow_replay', checked)}
                    checked={action.allow_replay}
                />

                <CheckboxLabel
                    label={
                        <span>
                            {t('ticket.moderation.statusesTransitions.transition.steps.actions.activateCommentLabel')}
                            <TooltipHelp triggerOnHover title={t('ticket.moderation.statusesTransitions.transition.steps.actions.activateCommentDesc')} />
                        </span>
                    }
                    onChange={({ target: { checked } }) => handleAction('comment_required', checked ? false : null)}
                    checked={action.comment_required === null ? false : true}
                />

                {action.comment_required !== null && (
                    <Section className={css['action-section']}>
                        {t('ticket.moderation.statusesTransitions.transition.steps.actions.comment_required.select')}
                        <div>
                            <RadioLabel bordered inline checked={!action.comment_required} name="comment_required" onClick={() => handleAction('comment_required', false)}>
                                {t('ticket.moderation.statusesTransitions.transition.steps.actions.comment_required.optional')}
                            </RadioLabel>
                            <RadioLabel bordered inline checked={action.comment_required} name="comment_optional" onClick={() => handleAction('comment_required', true)}>
                                {t('ticket.moderation.statusesTransitions.transition.steps.actions.comment_required.mandatory')}
                            </RadioLabel>
                        </div>
                    </Section>
                )}
            </OptionalSection>
        </>
    );
};

export default EmailAction;
